import { getCookie } from 'cookies-next';

import { AUTH_COOKIE_KEY } from '@/utils/constants/common';

/** Whether the browser holds CBS_COM; streaming-url fails without it. */
export function hasAuthCookie(): boolean {
    const value = getCookie(AUTH_COOKIE_KEY);
    return typeof value === 'string' && value.trim().length > 0;
}
